import { useTranslation } from 'react-i18next'

export const BACK_LABEL_KEY = 'common-ui:back.action'
export const BACK_LABEL_DEFAULT = 'Back'

/**
 * Every label the navigation card and its handle share, translated in one
 * place so a row is called the same thing wherever it appears.
 */
export default function useNavRowLabels() {
  const { t } = useTranslation()

  return {
    navigationLabel: t('discovery.nav.aria-label', 'Experience navigation'),
    openLabel: t('discovery.nav.open-navigation', 'Open navigation'),
    closeLabel: t('common-ui:close.action', 'Close'),
    backLabel: t(BACK_LABEL_KEY, BACK_LABEL_DEFAULT),
    allExperiencesLabel: t('discovery.nav.all-experiences', 'All experiences'),
    kidsReturnLabel: t('shared.close-activity', 'Back to activities'),
    leaveKioskLabel: t('kiosk-menu.leave-kiosk', 'Leave Kiosk'),
  }
}
